export default "__VITE_ASSET__BkL67TR___"